import React, { useState } from "react";
import blogImage from '../img/blog_image-1.jpeg';
import blogImage_2 from '../img/blog_image-3.jpg';
import blogImage_3 from '../img/blog_image-4.png';

const BlogSection = () => {
    const [selectedBlog, setSelectedBlog] = useState(null);

    const blogs = [
        {
            title: "Front-End Course Completed at CodeNetic Academy",
            date: "1/12/2024",
            excerpt: "Finalized my front-end course, gaining skills in HTML, CSS, JavaScript, and React.",
            image: blogImage_3,
            link: "https://www.facebook.com/p/Codenetic-61559786821933/?locale=en_GB",
        },
        {
            title: "How AI is Transforming Web Development",
            date: "Dec 20, 2024",
            excerpt:
                "Explore the latest advancements in AI and how they are shaping the future of web design and development.",
            image: blogImage,
            link: "/blog/ai-web-development",
        },
        {
            title: "The Ultimate Guide to Building Scalable Apps",
            date: "Dec 10, 2024",
            excerpt:
                "Learn how to design systems that grow with your business needs.",
            image: blogImage_2,
            link: "/blog/scalable-apps",
        },
    ];

    const handleBlogClick = (blog) => {
        setSelectedBlog(blog);
    };

    const closeModal = () => {
        setSelectedBlog(null);
    };

    return (
        <div className="bg-gray-900 text-gray-300 py-12 px-6">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-teal-400 mb-6">
                    Latest Insights & Updates
                </h2>
                <p className="text-center text-gray-400 mb-12">
                    Stay updated with the latest articles and tutorials from my desk.
                </p>

                {/* Blog Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {blogs.map((blog, index) => (
                        <div
                            key={index}
                            className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-teal-400 transition duration-300 cursor-pointer"
                            onClick={() => handleBlogClick(blog)}
                        >
                            <div className="overflow-hidden">
                                <img
                                    src={blog.image}
                                    alt={blog.title}
                                    className="w-full h-48 object-cover transform transition-transform duration-300 hover:scale-105"
                                />

                            </div>

                            <div className="p-4">
                                <h3 className="text-xl font-semibold text-teal-400 mb-2 hover:text-teal-300 transition duration-300">
                                    {blog.title}
                                </h3>
                                <p className="text-sm text-gray-400 mb-4">{blog.date}</p>
                                <p className="text-gray-300 mb-4">{blog.excerpt}</p>
                                <a
                                    target="_blank"
                                    href={blog.link}
                                    className="text-teal-400 hover:underline transition duration-300"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    Read More →
                                </a>
                            </div>
                        </div>
                    ))}

                    {/* Button All Show Posts */}

                    {/* <div className="text-center mt-12 flex justify-center items-center">
                        <a
                            href="/blog"
                            className="bg-teal-400 text-center text-gray-900 py-3 px-6 rounded-lg shadow-lg hover:bg-teal-500 transition duration-300"
                        >
                            Explore All Posts
                        </a>
                    </div> */}
                </div>

                {/* Modal */}
                {selectedBlog && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
                        onClick={closeModal}
                    >
                        <div
                            className=" bg-gray-800 text-gray-300 p-6 rounded-lg max-w-lg shadow-lg relative"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="absolute top-1 right-2 text-gray-500 hover:text-gray-300"
                                onClick={closeModal}
                            >
                                ✕
                            </button>

                            <div className="overflow-hidden">

                                <img
                                    src={selectedBlog.image}
                                    alt={selectedBlog.title}
                                    className="w-full h-64 object-cover rounded mb-4 transform transition-transform duration-300 hover:scale-105"
                                />
                            </div>

                            <h3 className="text-2xl font-semibold text-teal-400 mb-2">
                                {selectedBlog.title}
                            </h3>
                            <p className="text-sm text-gray-400 mb-4">{selectedBlog.date}</p>
                            <p className="text-gray-300 mb-4">{selectedBlog.excerpt}</p>
                            <a
                                target="_blank"
                                href={selectedBlog.link}
                                className="text-teal-400 hover:underline"
                            >
                                Read More →
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogSection;
